import alertCircle from '@/assets/icons/alert-gray.svg'
import { NOTICE_HEADER, NOTICE_SECTIONS } from '@/pages/gacha/steps/CouponStep/sections/FooterSection/constants'

import { BulletList, Container, HeaderDesc, HeaderRow, HeaderTitle, Hr, Section, Title, WarningInfoRow } from './styles'

export default function NoticeSection() {
  return (
    <Container>
      <Hr />
      <WarningInfoRow>
        <HeaderRow>
          <img src={alertCircle} alt='alert-circle' width={20} height={20} />
          <HeaderTitle>{NOTICE_HEADER.title}</HeaderTitle>
        </HeaderRow>
        <HeaderDesc>{NOTICE_HEADER.description}</HeaderDesc>
      </WarningInfoRow>

      {NOTICE_SECTIONS.map(({ title, items }) => (
        <Section key={title}>
          <Title>{title}</Title>
          <BulletList>
            {items.map((text) => (
              <li key={text}>{text}</li>
            ))}
          </BulletList>
        </Section>
      ))}
    </Container>
  )
}
